import type { LayoutPluginOptions } from '@atlaskit/editor-plugin-layout';

export function layoutPluginOptions(): LayoutPluginOptions {
	return {
		allowBreakout: true,
		UNSAFE_addSidebarLayouts: true,
		useLongPressSelection: false,
		UNSAFE_allowSingleColumnLayout: undefined,
		editorAppearance: 'full-page',
	};
}
